import { useEffect } from 'react';
import { useAppSelector } from '@/store';
import * as Sentry from '@sentry/react';

export const useSetSentryIdentifier = () => {
  const current = useAppSelector((state) => state.auth.current);

  useEffect(() => {
    if (current.isLoggedIn) {
      Sentry.setContext('identifier', {
        userId: current.me.id,
        gloplaId: current.organization.gloplaId,
      });
    } else {
      Sentry.getCurrentScope().clear();
    }
  }, [current]);
};
